import Head from 'next/head'
import Image from 'next/image'
import Nav from '@/components/Nav';
import Footer from '@/components/Footer';
import FeaturedPosts from '@/components/posts/FeaturedPosts';
import groq from 'groq';
import client from '../sanity_client';
import {urlFor} from '../sanity_image';
import {toHTML} from '@portabletext/to-html';
import React, { useState } from "react";
import Banner from '@/components/PageBanner';
import ContactForm from '@/components/ContactForm';

export default function PrivacyPolicy({pageContent, siteSettings}:any) {
  return (
    <>
      <Head>
        <title>The Line of Sight &#8480;</title>
      </Head>
      <Nav />
      <main className="row contents-row">
        <Banner bannerHeading={pageContent[0].banner_heading} bannerSubHeading={pageContent[0].banner_sub_heading} bannerImage={urlFor(pageContent[0].banner_image).width(1920).url()} />
        <div className="col-12">
          <div className="container">
            <div className="row">
              <div className="col-12" dangerouslySetInnerHTML={{__html: toHTML(pageContent[0].content)}}>
              {/* */}
              </div>
            </div>
          </div>
        </div>
        <ContactForm adminEmails={siteSettings[0].admin_emails} />
      </main>
      <Footer/>
    </>
  )
}

export async function getServerSideProps() {
  const pageContent = await client.fetch(groq`*[_type == "privacyPolicyPage"]`);
  const siteSettings = await client.fetch(groq`*[_type == "siteSettings"]`);
  return {
    props: {
      pageContent: pageContent,
      siteSettings: siteSettings
    }
  }
}
